import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { Flex, Box } from 'reflexbox';
import { Text } from 'rebass';

import TalentTraits from 'shared/talentTraits';
import { MAX_LEVEL } from 'shared/constants';

/*
import {
  If,
} from 'frontend/components';

import config from 'frontend/config';
*/
import actions from 'frontend/state/actions';
import { sizeMap } from 'frontend/components/WowIcon';
import {
  HeroTreeIcon,
  Icon,
  If,
} from 'frontend/components';

import config from 'frontend/config';

import { TalentTrait } from './TalentTree';

// Takes talent string of simc form (1231231, 1-indexed)
const TalentStrip = ({
  talents,
  baseTalents,
  specId,
  level,
  size,
  flat,
  hideRemoved,
  loadoutName,
  onShowTree,
  ...rest
}) => {
  const sizePx = sizeMap[size] || size;

  const parsed = TalentTraits.parse(talents);
  if (!parsed) {
    return null;
  }

  let entries = parsed.entries;
  let diff;
  let heroDiff = false;
  if (baseTalents) {
    const base = TalentTraits.parse(baseTalents);
    diff = TalentTraits.diff(parsed, base);
    entries = _.concat(
      diff.onlyA,
      _.map(diff.onlyB, entry => ({
        ...entry,
        removed: true,
      })),
    );
    heroDiff = !_.isEqual(base.activeSubtrees, parsed.activeSubtrees);
  }

  let heroIconSize = sizePx * 2;
  if (heroDiff) {
    heroIconSize = sizePx * 1.5;
  }

  const showHeroIcon = !baseTalents || heroDiff;

  let justify = rest.justify || 'flex-start';
  let align = rest.align || 'flex-start';

  if (flat) {
    justify = 'center';
    align = 'center';
  }

  if (entries.length === 0) {
    return null;
  }

  const traitLines = _.omit(
    _.groupBy(entries, 'entry.tree'),
    'subtree',
  );

  const subTreeId = _.first(parsed.activeSubtrees);

  return (
    <Flex align="center">
      <Box mr={1} style={{ lineHeight: 1, marginTop: 3 }}>
        <Icon
          name="expand"
          title="Show Full Tree"
          size={flat ? 0.7 * size : 1.4 * size}
          color={config.colors.orange}
          onClick={(e) => {
            e.stopPropagation();
            onShowTree(talents, specId, level);
          }}
          style={{
            cursor: 'pointer',
          }}
        />
      </Box>
      <If
        condition={_.trim(loadoutName)}
        then={() => (
          <Text>{loadoutName}</Text>
        )}
        else={() => (
          <Flex align="center">
            <If
              condition={subTreeId && showHeroIcon}
              then={() => (
                <Box mr={1}>
                  <HeroTreeIcon
                    subTreeId={subTreeId}
                    size={heroIconSize}
                    selected
                  />
                </Box>
              )}
            />
            <Flex flexColumn={!flat} align={align} justify={justify}>
              {_.map(traitLines, (nodes, idx) => {
                return (
                  <Flex
                    key={_.first(nodes)?.entry?.tree || idx}
                    align="center"
                    {...rest}
                  >
                    {_.map(nodes, (node) => {
                      if (!node || !node.entry) {
                        return null;
                      }
                      if (node.removed && hideRemoved) {
                        return null;
                      }
                      const nodeSubTreeId = node?.entry?.node?.subTreeId;
                      if (nodeSubTreeId && !_.includes(parsed.activeSubtrees, nodeSubTreeId)) {
                        return null;
                      }

                      const iconSize = node?.entry?.tree === 'spec' ? sizePx : _.round(sizePx * 1);

                      return (
                        <Box key={_.join([node.entry.id, node.rank], ':')} style={{ marginRight: 5 }}>
                          <TalentTrait
                            node={{
                              ...node.entry.node,
                              rank: node.rank,
                              chosenEntryId: node.entry.id,
                            }}
                            size={iconSize}
                            borderSize={2}
                            state={node.removed ? 'locked' : 'display'}
                            specId={specId}
                            disableHover
                          />
                        </Box>
                      );
                    })}
                  </Flex>
                );
              })}
            </Flex>
          </Flex>
        )}
      />
    </Flex>
  );
};

TalentStrip.propTypes = {
  talents: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  baseTalents: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  specId: PropTypes.number,
  level: PropTypes.number,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  flat: PropTypes.bool,
  hideRemoved: PropTypes.bool,
  loadoutName: PropTypes.string,

  onShowTree: PropTypes.func,
};

TalentStrip.defaultProps = {
  talents: '',
  baseTalents: '',
  specId: null,
  level: MAX_LEVEL,
  size: 'medium',
  flat: false,
  hideRemoved: false,
  loadoutName: null,

  onShowTree: () => {},
};

const mapDispatchToProps = {
  onShowTree: actions.setTalentTreeOverlay,
};

export default connect(undefined, mapDispatchToProps)(TalentStrip);
